import React from "react";

function ConfirmationModal({ deleteEvent, setIsConfirmationModalOpen, id }) {
  const handleDelete = () => {
    deleteEvent(id);
    setIsConfirmationModalOpen(false);
  };

  return (
    <div className="bg-bg-modal fixed w-screen h-screen top-0 left-0 overflow-hidden z-20">
      <div className="lg:w-3/12 w-11/12 h-1/4 m-auto bg-white mt-44 rounded-xl relative flex justify-center items-center">
        <div>
          <div className="text-center">
            <h3 className="font-semibold text-xl">Delete Event</h3>
            <p className="capitalize my-1">
              Are you sure you want to delete this event?
            </p>
          </div>

          <div className="flex justify-between gap-2 mt-10 w-full">
            <button
              onClick={() => {
                setIsConfirmationModalOpen(false);
              }}
              className="h-14 w-full bg-green-50 text-white p-2 flex justify-center items-center rounded-lg hover:opacity-70"
            >
              No, Cancel
            </button>
            <button
              onClick={() => {
                handleDelete();
              }}
              className="h-14 w-full bg-red-50 text-white p-2 flex justify-center items-center rounded-lg hover:opacity-70"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
